import { useState } from "react";

interface SegmentedControlProps {
	tabs?: string[];
	defaultIndex?: number;
	onChange?: (index: number, label: string) => void;
}

export function SegmentedControl({
	tabs = ["Team A", "Team B"],
	defaultIndex = 0,
	onChange,
}: SegmentedControlProps) {
	const [activeIndex, setActiveIndex] = useState(defaultIndex);

	const handleSelect = (index: number) => {
		setActiveIndex(index);
		onChange?.(index, tabs[index]);
	};

	return (
		<div className="bg-[rgba(118,118,128,0.12)] flex items-center px-[4px] py-[2px] rounded-[8.91px] w-full">
			{tabs.map((label, index) => (
				<button
					key={label}
					onClick={() => handleSelect(index)}
					className={[
						"relative flex-1 h-[28px] rounded-[6.93px] transition-all duration-200 cursor-pointer",
						activeIndex === index
							? "bg-white shadow-[0px_3px_8px_0px_rgba(0,0,0,0.12),0px_3px_1px_0px_rgba(0,0,0,0.04)]"
							: "bg-transparent",
					].join(" ")}
				>
					{activeIndex === index && (
						<span
							aria-hidden="true"
							className="absolute inset-[-0.5px] rounded-[7.43px] border-[0.5px] border-[rgba(0,0,0,0.04)] border-solid pointer-events-none"
						/>
					)}
					<span className="relative z-10 block text-[14px] text-black text-center tracking-[-0.15px] font-semibold leading-[19px] select-none">
						{label}
					</span>
				</button>
			))}
		</div>
	);
}
